import { List, Map, fromJS } from 'immutable';

import * as constAction from 'root/actionConstants';
import { listFindByMapId } from 'core/generalFunctions';

const defaultState = Map({
  lista: List(),
  rutina: Map(),
  paradas: List(),
  eliminarId: false,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.RUTINAS_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.RUTINAS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.RUTINAS_DELETE: {
      let index = listFindByMapId(state.get('lista'), action.state.id, true);
      return state.deleteIn(['lista', index]);
    }
    case constAction.RUTINAS_LISTA_SET: {
      let newState = state.get('lista'),
        index = listFindByMapId(newState, action.payload.id, true);
      newState = index === -1 ? newState.push(Map(action.payload)) : newState.set(index, Map(action.payload));
      return state.set('lista', newState);
    }
    case constAction.RUTINAS_SET_GRUPOS: {
      let newGrupos = state.getIn(['rutina', 'grupos']) || List();
      const index = newGrupos.findIndex(grupoId => grupoId == action.payload.grupoId);
      if (index === -1 && action.payload.agregar) {
        newGrupos = newGrupos.push(action.payload.grupoId);
        return state.setIn(['rutina', 'grupos'], newGrupos);
      } else if (index !== -1 && !action.payload.agregar) {
        return state.deleteIn(['rutina', 'grupos', index]);
      } else return state;
    }
    case constAction.ABONADOS_SET_RUTINAS_PARADAS: {
      let index = listFindByMapId(state.get('lista'), action.payload.rutinaId, true);
      return state.setIn(['lista', index, 'paradas'], fromJS(action.payload.data));
    }
  }
  return state;
}



// WEBPACK FOOTER //
// src/modules/rutinas/reducer.js